import React, { useState } from 'react';
import { useField, useFormikContext } from 'formik';
import styles from "layout/Auth/Auth.module.scss";
import { AttachmentIcon, DocumentIcon, RemoveIcon } from "Assets/icons";
import { Button } from "react-bootstrap";
import { uploadFile } from "utils/common";
import { useUploadFileMutation } from "store/services/utility";
import LoadingIndicator from "../LoadingIndicator";
import { isArray, isEmpty } from "lodash";
import SingleUploadedFileDetail from "./SingleUploadedFileDetail";

const AppFileUploadField = ({ label, acl, allowedTypes = [], onChange, handleRemove, preview, isMulti = true, ...props }) => {
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const { setFieldValue, values } = useFormikContext();
  const [field, meta] = useField(props);

  const handleFileChange = async (event) => {
    const input = event.currentTarget;
    try {
      const file = event.currentTarget.files[0];
      if (file) {
        if (allowedTypes.length && !allowedTypes.includes(file.type)) {
          alert('File type not allowed.');
          input.value = "";
          return;
        }

        const response = await uploadFile({ file, acl });
        if (!response?.error) {
          if (typeof onChange === "function") {
            onChange(field.name, response?.data);
          } else {
            setFieldValue(field.name, response?.data);
          }
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    } finally {
      input.value = "";
    }
  };

  const handleRemoveFile = async (index) => {
    if(isMulti) {
      if (index || index == 0) {
        const files = [...values[field.name]];
        if (typeof handleRemove == "function") handleRemove(files[index]);
  
        delete files[index];
        setFieldValue(field.name, files.filter(Boolean));
      } else {
        setFieldValue(field.name, isArray(values[field.name]) ? [] : "");
      }
    } else {
      if (typeof handleRemove == "function") handleRemove(values[field.name]);
      setFieldValue(field.name, "");
    }
  };
  return (
    <>
      <div className="iconWithText position-relative">
        <input
          type="file"
          onChange={handleFileChange}
          className={`${styles.formControl} form-control`}
          {...props}
        />
        <span
          className="icn position-absolute"
          style={{ right: 5 }}
        >
          <AttachmentIcon />
        </span>
        {isUploading && (
          <span
            className="icn position-absolute"
            style={{ right: 25 }}
          >
            <LoadingIndicator />
          </span>
        )}
      </div>
      <ul
        className={`${styles.list} list-unstyled ps-2 mb-0 pt-2`}
        style={{ maxWidth: 300 }}
      >
        {!values[field.name] ? (
          null
        ) : isArray(values[field.name]) ? (
          values[field.name].map((item, index) => {
            return (
              <SingleUploadedFileDetail
                value={item?.attachment_name}
                handleRemoveFile={() => handleRemoveFile(index)}
              />
            )
          })
        ) : (
          <SingleUploadedFileDetail
            preview={preview}
            value={values[field.name]}
            handleRemoveFile={handleRemoveFile}
          />
        )}
      </ul>
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
};

export default AppFileUploadField;
